import React, { useCallback, useEffect, useState } from "react";
import "../Wallet/Passbook.css";
import { Helmet } from "react-helmet";
import Sidebar from "../Sidebar";
import DeshBoardFooter from "../DeshBoardFooter";
import { useAuth } from "../../../Store/AuthContext";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import { Link, useParams } from "react-router-dom";
import NotifyMessageNoReload from "../../Others/NotifyMessageNoReload";
import axios from "axios";
import APIDataFetchLoader from "../../Others/APIDataFetchLoader";
import LeadTransactionReceiptModal from "./LeadTransactionReceiptModal";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";

export default function SingleLeadTransactionDetails() {
  let { orderid } = useParams();
  // console.log(transactionid);
  const { userID, RendomTokenfetch, profileData } = useAuth();
  const [TransactionData, setTransactionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Sample transaction data - replace with your actual data
  // Sample transaction data

  const FetchTransaction = useCallback(async () => {
    let fdata = new FormData();
    fdata.append("user_id", userID);
    fdata.append("orderid", orderid);
    setLoading(true);
    try {
      await axios
        .post(`${WebsiteAPIurl}leadtransactiondetails`, fdata, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data.status === "1") {
            setTransactionData(response.data.TransactionDetailData);
          }
          if (response.data.status === "0") {
            setTransactionData([]);
            NotifyMessageNoReload(response.data.message, "danger");
          }
        });
    } catch (error) {
      console.error("Error fetching leads:", error);
    } finally {
      setLoading(false);
    }
  }, [RendomTokenfetch, orderid, userID]);

  useEffect(() => {
    FetchTransaction();
  }, [FetchTransaction]);

  const transaction = {
    name: profileData?.username || "",
    email: profileData?.email || "",
    phone: profileData?.number || "",
    address: profileData?.address || "",
    amount: TransactionData?.amount || 0,
    account_id: TransactionData?.account_id || "",
    credit_debit: TransactionData?.credit_debit || "",
    payment_date: TransactionData?.date || "",
    description: TransactionData?.description || "",
    lead_id: TransactionData?.lead_id || "",
    order_id: TransactionData?.order_id || "",
    paid_type: TransactionData?.paid_type || "",
    payment_mode: TransactionData?.payment_mode || "",
    receipt_id: TransactionData?.receipt_id || "",
    seller_user_id: TransactionData?.seller_user_id || "",
    transaction_order_id: TransactionData?.transaction_order_id || "",
    transaction_id: TransactionData?.transaction_id || "",
  };
  if (loading) {
    return <APIDataFetchLoader />;
  }

  const PaidType_status = (paid_type) => {
    let paid_type_status;
    let showBordersStyle;
    let showTextStyle;
    if (paid_type === "1") {
      paid_type_status = <span className="badge bg-success">Paid</span>;
      showBordersStyle = "border-success";
      showTextStyle = "text-success";
    } else if (paid_type === "2") {
      paid_type_status = <span className="badge bg-danger">Cancel</span>;
      showBordersStyle = "border-danger";
      showTextStyle = "text-danger";
    } else {
      paid_type_status = <span className=" badge bg-info">Unpaid</span>;
      showBordersStyle = "border-info";
      showTextStyle = "text-info";
    }

    return { paid_type_status, showBordersStyle, showTextStyle };
  };

  const { paid_type_status, showBordersStyle, showTextStyle } = PaidType_status(
    transaction.paid_type
  );

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "Service Booking", pagelink: "service-booking" },
            {
              name: `Lead Transaction Details`,
              pagelink: `lead-transaction-details/${transaction.lead_id}`,
            },
            { name: "Single Transaction Details" },
          ]}
        />
        <section className="user-dashboard">
          <div className="dashboard-outer walletDetails">
            <div
              className="newspapermultyupdatebox"
              style={{ borderBottom: "unset" }}
            >
              <div className="row my-1">
                <div className="col-lg-12 col-md-12  mt-1">
                  <Link
                    to={`/lead-transaction-details/${transaction.lead_id}`}
                    className="DefaultHoverbtn handleServiceStatus"
                  >
                    <span>
                      <i className="fa fa-arrow-left me-2"></i>
                    </span>{" "}
                    Back
                  </Link>
                </div>
              </div>
            </div>

            <div
              className={`transaction_header p-4 mb-4 border border-success  ${showBordersStyle}`}
              style={{ maxWidth: "920px", backgroundColor: "rgb(229 229 229)" }}
            >
              <div className="d-flex align-items-center justify-content-between">
                <div className="">
                  <h4 className="mb-1 text-dark fw-600">Payment </h4>
                  <p className="mb-0 text-dark">
                    Completed on {transaction.payment_date}
                  </p>
                </div>
                <div className="text-md-end">
                  <h3 className="text-light mb-0">
                    {/* ₹{transaction.amount} */}
                    <span className={` ${showTextStyle}`}>
                      {`₹${transaction.amount}`}
                    </span>
                  </h3>
                  {/* <span
                    className={`badge ${
                      transaction.credit_debit === "1"
                        ? "bg-success"
                        : "bg-danger"
                    }`}
                  >
                    {transaction.credit_debit === "1" ? "Credit" : "Debit"}
                  </span> */}
                  {paid_type_status}
                </div>
              </div>
            </div>
            <div className="payment-container" style={{ maxWidth: "920px" }}>
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  {/* <div className="divider"></div> */}

                  <div className="details-section">
                    <h3>
                      <i className="fa fa-info-circle me-2"></i>Transaction
                      Details
                    </h3>

                    <table className="details-table">
                      <tbody>
                        {transaction.transaction_id && (
                          <tr>
                            <td className="label">Transaction ID</td>
                            <td>{transaction.transaction_id}</td>
                          </tr>
                        )}
                        {transaction.transaction_order_id && (
                          <tr>
                            <td className="label">Transaction Order ID.</td>
                            <td>{transaction.transaction_order_id}</td>
                          </tr>
                        )}
                        {transaction.receipt_id && (
                          <tr>
                            <td className="label">Receipt ID</td>
                            <td>{transaction.receipt_id}</td>
                          </tr>
                        )}
                        {transaction.order_id && (
                          <tr>
                            <td className="label">Order ID</td>
                            <td>{transaction.order_id}</td>
                          </tr>
                        )}

                        {transaction.lead_id && (
                          <tr>
                            <td className="label">Lead ID</td>
                            <td>{transaction.lead_id}</td>
                          </tr>
                        )}

                        {transaction.account_id && (
                          <tr>
                            <td className="label">Account ID</td>
                            <td>{transaction.account_id}</td>
                          </tr>
                        )}
                        {transaction.seller_user_id && (
                          <tr>
                            <td className="label">Seller User ID</td>
                            <td>{transaction.seller_user_id}</td>
                          </tr>
                        )}

                        <tr>
                          <td className="label">Status</td>
                          <td>{paid_type_status}</td>
                        </tr>

                        <tr>
                          <td className="label">Payment Type</td>
                          <td>
                            {" "}
                            <span
                              className={`badge ${
                                transaction.credit_debit === "1"
                                  ? "bg-info"
                                  : "bg-danger"
                              }`}
                            >
                              {transaction.credit_debit === "1"
                                ? "Credit"
                                : "Debit"}
                            </span>
                          </td>
                        </tr>
                        {transaction.payment_mode && (
                          <tr>
                            <td className="label">Payment Mode</td>
                            <td>{transaction.payment_mode}</td>
                          </tr>
                        )}

                        <tr>
                          <td className="label">Payment Date</td>
                          <td>{transaction.payment_date}</td>
                        </tr>

                        {transaction.description && (
                          <tr>
                            <td className="label">Description</td>
                            <td>{transaction.description}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* <div className="divider"></div>

                  <div className="details-section">
                    <h3>
                      <i className="fa fa-user me-2"></i>User Details
                    </h3>

                    <table className="details-table">
                      <tbody>
                        <tr>
                          <td className="label">User Name</td>
                          <td>{transaction.name}</td>
                        </tr>
                        <tr>
                          <td className="label">Mobile Number</td>
                          <td>{transaction.phone}</td>
                        </tr>
                        <tr>
                          <td className="label">Email Address</td>
                          <td>{transaction.email}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div> */}
                </div>
                <div className="divider"></div>
                <div className="col-xl-12 col-lg-12 col-md-12 text-center">
                  <div>
                    <button
                      className="theme-btn btn-style-three submitbtn"
                      style={{ marginRight: "12px" }}
                      onClick={() => setShowModal(true)}
                    >
                      <i className="fa fa-download mx-2" aria-hidden="true"></i>{" "}
                      Download Receipt
                    </button>
                    <LeadTransactionReceiptModal
                      show={showModal}
                      onClose={() => setShowModal(false)}
                      transaction={transaction}
                      paid_type_status={paid_type_status}
                      showBordersStyle={showBordersStyle}
                      showTextStyle={showTextStyle}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter RendomTokenfetch={RendomTokenfetch} />
        </div>
      </div>
    </>
  );
}
